let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("edPhJ"), load("LqNdf"), load("fSV9f"), load("78EJ0")]).then(() => parcelRequire('c0sxZ'));